import mvtArticle from '@/common/components/mvtarticle/mvt-article.vue';
import mvtFaq from '@/common/components/mvtfaq/mvt-faq.vue';
import mvtInputNumber from '@/common/components/mvtinputnumber/mvt-inputnumber.vue';
import mvtListProperty from '@/common/components/mvtlistproperty/mvt-listproperty.vue';
import mvtTextbox from '@/common/components/mvttextbox/mvt-textbox.vue';
import faqConf from '@/common/store/glb/data.faqs';
import mapper from '@/common/store/mapper/index.js';
import debounce from 'lodash/debounce';
import sort from '@/common/utilities/sort';
import mortgageTools from '@/staticpages/components/common/mortgagetools/mortgagetools.vue';
import { mapActions, mapGetters } from 'vuex';
import { defineAsyncComponent } from 'vue';
import { getPathBySearchObj } from '../../../../widget/spec/searchHelper';
const mvtRateTrend = defineAsyncComponent(() => import(/* webpackChunkName: "rateTrend" */ '@/common/components/mvtratetrend/mvt-ratetrend.vue'));
import * as utils from './utils';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import mvtLazyload from '@/common/components/mvtlazyload/mvt-lazyload.vue';
import { handleMortgagePageCta } from '@/common/utilities/mortgagePageCta.js';

export default {
    name: 'pageBuyingpower',
    inject: ['$eventBus'],
    components: {
        mvtDialogCenter,
        mvtArticle,
        mvtFaq,
        mortgageTools,
        mvtTextbox,
        mvtRateTrend,
        mvtListProperty,
        mvtInputNumber,
        mvtHeader,
        mvtFooter,
        mvtLazyload,
    },
    data() {
        return {
            faqQuery: null,
            tag: null,
            annualIncome: 0,
            downPayment: 0,
            monthlyDebts: 0,
            zipcode: 94403,
            state: 'ca',
            creditScore: 0,
            homePrice: 0,
            homeInsurance: 0,
            homeInsurancePerMonth: 0,
            hoafee: 0,
            hoaPerMonth: 0,
            hasHOADues: true,
            hasPropertyTax: true,
            pmiPerMonth: 0,
            taxPerMonth: 0,
            propertyTax: 0,
            loanPerMonth: 0,
            affordableListings: [],
            relatedArticles: [],
            faqs: [],
            buyingPowerSteps: [],
            dti: utils.DEFAULT_DTI_PERCENTAGE,
            interestOption: {
                loanYear: 30,
                interestRate: 4.5,
            },
            taxRateByState: {
                AL: 0.43,
                AK: 1.21,
                AS: 0, //American Samoa
                AZ: 0.84,
                AR: 0.62,
                CA: 0.81,
                CO: 0.62,
                CT: 1.91,
                DE: 0.53,
                DC: 0.57,
                FM: 0, //Federated States Of Micronesia
                FL: 1.1,
                GA: 0.96,
                GU: 0, //Guam
                HI: 0.28,
                ID: 0.77,
                IL: 2.25,
                IN: 0.88,
                IA: 1.47,
                KS: 1.41,
                KY: 0.84,
                LA: 0.48,
                ME: 1.27,
                MH: 0, //Marshall Islands
                MD: 1.08,
                MA: 1.18,
                MI: 1.83,
                MN: 1.19,
                MS: 0.78,
                MO: 1.0,
                MT: 0.87,
                NE: 1.88,
                NV: 0.92,
                NH: 2.1,
                NJ: 2.29,
                NM: 0.72,
                NY: 1.58,
                NC: 0.85,
                ND: 1.22,
                MP: 0, //Northern Mariana Islands,
                OH: 1.55,
                OK: 0.87,
                OR: 1.08,
                PW: 0, //Palau
                PA: 1.51,
                PR: 0, //Puerto Rico
                RI: 1.61,
                SC: 0.57,
                SD: 1.36,
                TN: 0.75,
                TX: 1.93,
                UT: 0.69,
                VT: 1.72,
                VI: 0, //Virgin Islands
                VA: 0.8,
                WA: 1.08,
                WV: 0.59,
                WI: 1.97,
                WY: 0.62,
            },
            showAffordableSec: true,
        };
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb', 'getSplit']),
        buyingPowerComfort() {
            if (this.monthlyDebts) {
                const comfort = Math.floor((this.monthlyDebts * 100 * 12) / this.annualIncome);
                if (comfort < 20) {
                    return 20;
                } else if (comfort > 50) {
                    return 50;
                } else {
                    return Math.floor((this.monthlyDebts * 100 * 12) / this.annualIncome);
                }
            } else {
                return 20;
            }
        },
        pricePerMonth() {
            return this.homeInsurancePerMonth + this.pmiPerMonth + this.hoaPerMonth + this.taxPerMonth + this.loanPerMonth;
        },
        chartData() {
            var data = [];
            var keys = ['Interest', 'Taxes', 'HOA', 'PMI', 'Insurance'];
            var classNames = ['interest', 'tax', 'hoa', 'pmi', 'insurance'];
            var price = [this.loanPerMonth, this.taxPerMonth, this.hoaPerMonth, this.pmiPerMonth, this.homeInsurancePerMonth];
            keys.map((v, i) => {
                data.push({
                    key: v,
                    className: classNames[i],
                    price: price[i] ? price[i] : 'NA',
                    value: price[i] ? Math.ceil((price[i] / this.pricePerMonth) * 100) + '%' : '0%',
                });
            });
            return data;
        },
    },
    created() {
        this.debouncedCalculateBuyingPower = debounce(this.calculateBuyingPower, 500);
        this.debouncedGetListings = debounce(this.getListings, 500);
    },
    mounted() {
        this.tag = this.glb.articleConfig.tag.buyer + '';
        this.faqQuery = faqConf.buyingPower;
        this.initialLoad().then(() => {
            let midValue = Math.floor(this.affordableListings.length / 2);
            if (midValue && this.affordableListings[midValue] && this.affordableListings[midValue + 1]) {
                const avgHomePrice = Math.round((this.affordableListings[midValue].price + this.affordableListings[midValue].price) / 2);
                this.downPayment = Math.round(avgHomePrice / 4);
                this.annualIncome = this.downPayment * 0.8;
                this.calculateBuyingPower();
            }
        });
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
    watch: {
        //annual income, down payment, debts, zip, credit score
        async zipcode(newZip, oldZip) {
            if (!newZip || newZip.length !== 5) return;
            const path = await this.getStateCode(newZip);
            if (path) {
                this.showAffordableSec = true;
                await this.debouncedGetListings(path);
                this.calculateBuyingPower();
            }
        },
        annualIncome: function () {
            this.debouncedCalculateBuyingPower();
        },
        downPayment: function () {
            this.debouncedCalculateBuyingPower();
        },
        monthlyDebts: function () {
            this.debouncedCalculateBuyingPower();
        },
        creditScore: function () {
            this.debouncedCalculateBuyingPower();
        },
        dti: function (newDti) {
            this.updateDti(newDti);
        },
        homePrice: function (newPrice) {
            const taxRate = this.taxRateByState[this.state] || 0;
            var loanYear = this.interestOption ? this.interestOption.loanYear : 0;
            var interestMonthRate = this.interestOption.interestRate / 100 / 12;

            this.homeInsurance = Math.round((newPrice / 2000) * 3.5);
            this.homeInsurancePerMonth = Math.round(this.homeInsurance / 12);
            this.downpaymentRate = this.round((this.downPayment / newPrice) * 100, 2);
            this.propertyTaxRate = taxRate;
            if (this.propertyTaxRate > 100) {
                this.propertyTaxRate = 100;
            } else if (this.propertyTaxRate < 0) {
                this.propertyTaxRate = 0;
            }
            this.propertyTax = Math.round((newPrice * this.propertyTaxRate) / 100);
            this.propertyTaxRate = this.round((this.propertyTax / newPrice) * 100, 2);
            var propertyTaxRate = this.hasPropertyTax ? this.propertyTaxRate / 100 || 0 : 0;
            var loanMonth = loanYear * 12;

            var loanAmount = newPrice - this.downPayment;
            var loanRate = loanAmount / newPrice;
            var PMI = this.downpaymentRate >= 20 ? 0 : this.calPMI(loanRate, loanYear);
            var pmiAnnualFee = PMI * loanAmount;
            var propertyHoafee = this.hasHOADues ? this.hoafee || 0 : 0;
            var taxAnnualAmount = propertyTaxRate * newPrice;

            var _l = Math.pow(1 + interestMonthRate, loanMonth);
            this.loanPerMonth = Math.round((loanAmount * (interestMonthRate * _l)) / (_l - 1));
            this.pmiPerMonth = Math.round(pmiAnnualFee / 12);
            this.hoaPerMonth = Math.round(propertyHoafee);
            this.taxPerMonth = Math.round(taxAnnualAmount / 12);
        },
    },
    methods: {
        ...mapActions('glb', ['findZipcode', 'fetchZipListByIP', 'fetchAllZipListings', 'fetchArticleFeeds', 'fetchFAQs', 'getGeoInfoBySearch']),

        async initialLoad() {
            const res = await this.fetchZipListByIP();
            this.zipcode = res.name;
            const stateCode = await this.getStateCode(this.zipcode);
            if (stateCode) {
                await this.getListings(stateCode);
            } else {
                this.showAffordableSec = false;
            }
        },
        async getStateCode(zipCode) {
            const res = await this.findZipcode(zipCode);
            if (res && res.length) {
                this.state = res[0].state;
                const path = this.getUrl(this.state, this.zipcode);
                return path;
            }
            return null;
        },
        async getListings(urlPath) {
            return this.fetchAllZipListings({ zipcodePath: urlPath }).then((res) => {
                if (res && res.data) {
                    const result = res.data.map((listing) => {
                        return mapper.property(listing, this.glb);
                    });
                    this.affordableListings = sort.sortProperty('price_asc', result);
                } else {
                    this.showAffordableSec = false;
                }
            });
        },
        updateDti(newDti) {
            const step = this.buyingPowerSteps.find((b) => newDti / 100 === b.dti);
            if (step) {
                this.homePrice = step.total;
            }
        },
        calculateBuyingPower() {
            this.monthlyPaymentCalculations();
        },
        getUrl(stateCode, zipcode) {
            return getPathBySearchObj({ zipcode: zipcode, stateCode: stateCode });
        },
        monthlyPaymentCalculations() {
            var loanYear = this.interestOption ? this.interestOption.loanYear : 0;
            var interestMonthRate = this.interestOption.interestRate / 100 / 12;
            const taxRate = this.taxRateByState[this.state] || 0;

            const calcPMI = this.calPMI(1 - this.downPayment / this.avgHomePrice, loanYear);
            const buyingPower = utils.computeBuyingPowerResultSet({
                monthlyMortgageRate: interestMonthRate,
                numOfMortgagePayments: 360,
                monthlyPMIRate: calcPMI,
                monthlyPropertyTaxRate: taxRate / 100 / 12,
                monthlyHomeInsuranceRate: 0.0054 / 12,
                monthlyIncome: this.annualIncome / 12,
                monthlyDebt: this.monthlyDebts,
                downpayment: this.downPayment,
            });
            const normal = utils.normalizeBuyingPowerResultsData(buyingPower);
            this.buyingPowerSteps = normal;
            if (this.dti !== utils.DEFAULT_DTI_PERCENTAGE * 100) {
                this.dti = utils.DEFAULT_DTI_PERCENTAGE * 100;
            } else {
                this.updateDti(this.dti);
            }
        },
        calPMI(loanRate, loanYear) {
            if (loanRate >= 0.9001 && loanRate <= 1 && loanYear === 30) {
                return 0.0062;
            }
            if (loanRate >= 0.9001 && loanRate <= 1 && loanYear === 20) {
                return 0.005867;
            }
            if (loanRate >= 0.9001 && loanRate <= 1 && loanYear === 15) {
                return 0.0057;
            }
            if (loanRate >= 0.8501 && loanRate <= 0.9 && loanYear === 30) {
                return 0.0044;
            }
            if (loanRate >= 0.8501 && loanRate <= 0.9 && loanYear === 20) {
                return 0.004067;
            }
            if (loanRate >= 0.8501 && loanRate <= 0.9 && loanYear === 15) {
                return 0.0039;
            }
            if (loanRate >= 0.8 && loanRate <= 0.85 && loanYear === 30) {
                return 0.0027;
            }
            if (loanRate >= 0.8 && loanRate <= 0.85 && loanYear === 20) {
                return 0.002367;
            }
            if (loanRate >= 0.8 && loanRate <= 0.85 && loanYear === 15) {
                return 0.0022;
            }
            return 0;
        },
        round(value, decimals) {
            return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
        },
        preApprovalPage(evt) {
            handleMortgagePageCta({
                getSplit: this.getSplit,
                glb: this.glb,
                zipcode: this.zipcode,
                utmContent: 'get_started',
                ctaLabel: 'Get Started',
                evt,
                eventBus: this.$eventBus,
                trigger: this.$options.name,
            });
        },
    },
};
